module.exports = __webpack_public_path__ + "media/application/images/ui/price-me-6208aa4ebb94aab2eda6e2e04760d9f5.svg";